import { initialState } from './reducer';

export interface INotificationsStore {}

export function getInitialNotificationsStore(): INotificationsStore {
  return { ...initialState };
}
